import { FormControl, FormGroup } from '@angular/forms';
import { GrocyContextData } from '../../../../core/entities/grocy/context-data/context-data.entity';
import { GrocyCurrentStock } from '../../../../core/entities/grocy/stock/current-stock.entity';

export class StockFilterForm {
  formGroup = new FormGroup({
    name: new FormControl(),
    productGroup: new FormControl(),
  });

  constructor(public contextData: GrocyContextData) {
    this.initializeForm();
  }

  get controls() {
    return this.formGroup.controls;
  }

  private initializeForm(): void {
    this.formGroup.setValue({ name: null, productGroup: null });
  }

  filterStock(stock: GrocyCurrentStock[]): GrocyCurrentStock[] {
    return stock.filter(stockItem => {
      const name = this.controls.name.value;
      const productGroup = this.controls.productGroup.value;

      return (
        (!name || this.isNameMatch(stockItem, name)) && (!productGroup || stockItem.productGroup.id === productGroup)
      );
    });
  }

  isNameMatch(stockItem: GrocyCurrentStock, name: string): boolean {
    if (stockItem.product.name.toLowerCase().includes(name.toLowerCase())) return true;

    if (stockItem.subStock) {
      return stockItem.subStock.some(subStock => this.isNameMatch(subStock, name));
    }

    return false;
  }
}
